import React from 'react';
import { Col, Row } from 'antd';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styles from './ProgressFooter.scss';

const ProgressFooter = () => {
  const { t } = useTranslation('common');

  const { total, answered, marked, skipped } = useSelector(state => state.mcq.progress);

  return (
    <div className={styles['progress-footer-wrapper']}>
      <div
        className={`${styles['progress-footer-container']} ${styles['progress-footer-container--no-sections']}`}
      >
        <Row
          gutter={32}
          justify="center"
          align="middle"
          className={styles['progress-footer']}
        >
          <Col>
            {t('progress_footer.questions')}:{' '}
            <span className={styles['progress-footer__total']}>
              {String(total).padStart(2, '0')}
            </span>
          </Col>

          <Col>
            {t('progress_footer.answered')}:{' '}
            <span className={styles['progress-footer__answered']}>
              {String(answered).padStart(2, '0')}
            </span>
          </Col>

          <Col>
            {t('progress_footer.marked_for_review')}:{' '}
            <span className={styles['progress-footer__marked']}>
              {String(marked).padStart(2, '0')}
            </span>
          </Col>

          <Col>
            {t('progress_footer.skipped')}:{' '}
            <span className={styles['progress-footer__skipped']}>
              {String(skipped).padStart(2, '0')}
            </span>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ProgressFooter;
